import React from 'react';
import { useHistory } from 'react-router-dom';
import CardActions from '@material-ui/core/CardActions';
import clsx from 'clsx';
import FPHint from 'UI/components/atoms/FPHint';

import { ImgContainer, StatsCardContent, StatsCardHeader, StyledCard } from './StatsCard.styled';

/**
 * @typedef {Object} StatsCardProps
 * @property {React.ReactNode} [children]
 * @property {React.ReactNode} [actionElement]
 * @property {string|React.ReactNode} [header]
 * @property {React.ReactNode} [headerAction]
 * @property {React.ReactNode} [footer]
 * @property {string} [hintText]
 * @property {React.ReactNode} [subheader]
 * @property {number} [paddingContent]
 * @property {string} [detailsUrl]
 */

/**
 * @param {StatsCardProps} props
 */
export const StatsCard = ({
  actionElement,
  header,
  headerAction,
  footer,
  hintText,
  subheader,
  children,
  paddingContent,
  detailsUrl
}) => {
  const router = useHistory();

  const handleClick = event => {
    if (!detailsUrl) return;
    if (event.ctrlKey || event.metaKey) {
      window.open(detailsUrl, '_blank');
      return;
    }

    router.push(detailsUrl);
  };

  return (
    <StyledCard>
      {header &&
        (typeof header !== 'string' ? (
          <ImgContainer onClick={handleClick}>{header}</ImgContainer>
        ) : (
          <StatsCardHeader
            action={headerAction}
            subheader={subheader}
            title={
              <>
                {header} {hintText && <FPHint hint={hintText} position="top" />}
              </>
            }
            titleTypographyProps={{ variant: 'h5' }}
          />
        ))}
      <StatsCardContent className={clsx({ cardContent: !header })} padding={paddingContent}>
        {children}
      </StatsCardContent>
      {actionElement && <CardActions>{actionElement}</CardActions>}
      {footer && footer}
    </StyledCard>
  );
};
